import { render } from "./AutoPostingSettings.vue?vue&type=template&id=5f626556&scoped=true"
import script from "./AutoPostingSettings.vue?vue&type=script&lang=js"
export * from "./AutoPostingSettings.vue?vue&type=script&lang=js"

import "./AutoPostingSettings.vue?vue&type=style&index=0&id=5f626556&scoped=true&lang=css"

import exportComponent from "/var/www/cms.dealersgear.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f626556"]])

export default __exports__